import CircularRectTextButton from "@/components/CircularButton/styled/CircularRectTextButton";
import CircularProgress from "@/components/CircularProgress";
import { iconSizes } from "@/utils/iconProps";
import { getProgressPillProps } from "@/utils/progressPill";
import { spacing } from "@/utils/spacing";
import { themeColors } from "@/utils/themeColors";
import { StudySessionProgressEnum } from "@knowt/syncing/graphql/schema";
import { Eye, Star } from "lucide-react";
import br from "@/styles/breakpoints.module.css";
import { CircularButtonProps } from "@/components/CircularButton";

const FilterButton = ({ children, sx, ...props }: CircularButtonProps) => {
    return (
        <CircularRectTextButton
            sx={{
                gap: spacing.XS,
                padding: `${spacing.SM}`,
                backgroundColor: themeColors.neutralWhite,
                height: "auto",
                width: "auto",
                ...sx,
            }}
            {...props}>
            {children}
        </CircularRectTextButton>
    );
};

export const ViewAllBtn = ({ onClick, isActive, total }) => {
    return (
        <FilterButton
            sx={{
                borderColor: isActive ? themeColors.neutralBlack : themeColors.neutralWhite,
                backgroundColor: isActive ? themeColors.neutralBlack : themeColors.neutralWhite,
            }}
            onClick={onClick}>
            <Eye size={iconSizes.SM} color={isActive ? themeColors.neutralWhite : undefined} />
            <span
                className="secondaryText1"
                style={{ color: isActive ? themeColors.neutralWhite : undefined }}
                data-testid="auto-id-d10d66d4-2420-4d4e-9af6-28e8d58bfc8c">
                View all ({total})
            </span>
        </FilterButton>
    );
};

export const SectionBtn = ({
    section,
    total,
    isActive,
    onClick,
}: {
    section: StudySessionProgressEnum;
    isActive: boolean;
    onClick: () => void;
    total: number;
}) => {
    const {
        backgroundColor,
        backgroundHoverColor,
        label,
        color = themeColors.neutralWhite,
        progressBg,
        progressValue,
    } = getProgressPillProps(section);

    return (
        <FilterButton
            sx={{
                borderColor: isActive ? backgroundColor : themeColors.neutralWhite,
                backgroundColor: isActive ? backgroundColor : themeColors.neutralWhite,
                "&:hover": {
                    backgroundColor: isActive ? backgroundHoverColor : themeColors.neutralWhite,
                },
            }}
            onClick={onClick}>
            <CircularProgress
                className={br.smDownDisplayNone}
                value={progressValue}
                size={"2rem"}
                thickness={8}
                bgColor={isActive ? progressBg : "#e4e4e4"}
                color={isActive ? color : "#000"}
                disableAnimation
            />
            <span
                className="secondaryText1"
                style={{ color: isActive ? color : undefined }}
                data-testid="auto-id-7b0e2b22-9dba-4872-87e2-f2ff1fda4789">
                {label} ({total})
            </span>
        </FilterButton>
    );
};

export const StarBtn = ({ isActive, onClick, total }) => {
    return (
        <FilterButton
            sx={{
                borderColor: isActive ? themeColors.neutralBlack : themeColors.neutralWhite,
                backgroundColor: isActive ? themeColors.neutralBlack : themeColors.neutralWhite,
            }}
            onClick={onClick}>
            <Star
                size={iconSizes.SM}
                fill={isActive ? themeColors.primary3 : undefined}
                color={isActive ? themeColors.primary3 : undefined}
            />
            <span
                className="secondaryText1"
                style={{ color: isActive ? themeColors.neutralWhite : undefined }}
                data-testid="auto-id-ac757eeb-75b7-40a9-b475-332ed3889072">
                Starred ({total})
            </span>
        </FilterButton>
    );
};
